import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'

import { dsColorNew } from '@palette'
import { GOALS } from '../@services/goals'
import { tileSx } from '../QuerySentence'


const gradientTile = { background: 'linear-gradient(135deg, #4a90d9 0%, #06B6D4 100%)', color: '#fff' }

/** Six questions, 3 × 2, above the form (CU-869fmk5ge piece 1, Curro's decision 1: cards in the page, skippable) */
export default function BIGoalCards({ goals }) {
	// CA 5: a question fills from the user's offices, currencies and last query; until they are here it waits
	const waiting = goals.loading
	return <Box data-tour="bi-goals" sx={{ pb: 2, mb: 2, borderBottom: `1px solid ${dsColorNew.grayBorder}` }}>
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.5 }}>
			<Box sx={tileSx(32)}><IconSeeker icon="compass" sx={{ fontSize: 14 }}/></Box>
			<Box>
				<Typography sx={{ fontSize: 15, fontWeight: 600, color: dsColorNew.textTitle, lineHeight: 1.3 }}>What do you want to know?</Typography>
				<Typography sx={{ fontSize: 13, color: dsColorNew.textMuted }}>
					{waiting
						? 'Loading your offices and your last query…'
						: 'Pick a question and we open the right screen or fill the form for you. You can change anything before searching.'}
				</Typography>
			</Box>
			<Box sx={{ flex: 1 }}/>
			<Button variant="text" onClick={goals.skip} endIcon={<IconSeeker icon="chevron-right" sx={{ fontSize: 11 }}/>} sx={{ textTransform: 'none', fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap' }}>
				Go straight to the form
			</Button>
		</Box>
		<Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 1.25 }}>
			{GOALS.map(goal => {
				const to = goals.target(goal)
				const opens = to.kind === 'dashboard'
				return <Box key={goal.id} component="button" type="button" disabled={waiting} aria-busy={waiting}
					onClick={() => !waiting && goals.pick(goal)} sx={{
					display: 'flex', gap: 1.5, alignItems: 'flex-start', textAlign: 'left', px: 1.75, py: 1.5, minHeight: 78,
					border: `1px solid ${dsColorNew.grayBorder}`, borderRadius: '12px', backgroundColor: '#fff', font: 'inherit', cursor: 'pointer',
					transition: 'border-color .15s, background-color .15s',
					'&:hover': { borderColor: dsColorNew.appBlue, backgroundColor: dsColorNew.hoverBgLight },
					'&:focus-visible': { outline: `2px solid ${dsColorNew.appBlue}`, outlineOffset: '1px' },
					'&:disabled': { cursor: 'progress', opacity: 0.55, borderColor: dsColorNew.grayBorder, backgroundColor: '#fff' },
				}}>
					<Box sx={{ ...tileSx(32), mt: '1px', ...(opens ? gradientTile : {}) }}>
						<IconSeeker icon={opens ? 'chart-line' : 'pen'} sx={{ fontSize: 13 }}/>
					</Box>
					<Box sx={{ minWidth: 0 }}>
						<Typography sx={{ fontSize: 14, fontWeight: 600, color: dsColorNew.textTitle, lineHeight: 1.35 }}>{goal.question}</Typography>
						{opens
							? <>
								<Typography sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 0.75, fontSize: 12.5, fontWeight: 500, color: dsColorNew.appBlue }}>
									Opens {goal.dashboard.title}<IconSeeker icon="chevron-right" sx={{ fontSize: 10, color: dsColorNew.appBlue }}/>
								</Typography>
								{!!goal.dashboard.view && <Typography sx={{ mt: '2px', fontSize: 12.5, color: dsColorNew.textMuted }}>{goal.dashboard.view}</Typography>}
							</>
							: <Typography sx={{ mt: 0.75, fontSize: 12.5, color: dsColorNew.textMuted }}>{goal.fills}</Typography>}
					</Box>
				</Box>
			})}
		</Box>
	</Box>
}
